export default {
    props: {
        popupAppendTo: {
            type: String,
            kComposite: 'popup.appendTo'
        }, 
        popupOrigin: {
            type: String,
            kComposite: 'popup.origin'
        }, 
        popupPosition: {
            type: String,
            kComposite: 'popup.position'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/Common/Popup.js